import { render, staticRenderFns } from "./l-default.vue?vue&type=template&id=c386e35e&lang=pug&"
import script from "./l-default.vue?vue&type=script&lang=js&"
export * from "./l-default.vue?vue&type=script&lang=js&"
import style0 from "./l-default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c386e35e')) {
      api.createRecord('c386e35e', component.options)
    } else {
      api.reload('c386e35e', component.options)
    }
    module.hot.accept("./l-default.vue?vue&type=template&id=c386e35e&lang=pug&", function () {
      api.rerender('c386e35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/l-default.vue"
export default component.exports